import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import _css from "./TopBar.module.scss";

const TopBarBeforeLogin: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={_css.auth_buttons}>
      {location.pathname !== "/sign_in" && (
        <button className={_css.login_btn} onClick={() => navigate("/sign_in")}>
          Se connecter
        </button>
      )}
      {location.pathname !== "/register/user" && (
        <button className={_css.register_btn} onClick={() => navigate("/register/user")}>
          S'inscrire
        </button>
      )}
    </div>
  );
};

export default TopBarBeforeLogin;
